import { create } from '@thoughtspot/logger';
const logger = create('microfrontends-util');
export var Microfrontend;
(function (Microfrontend) {
    Microfrontend["EUREKA"] = "eureka";
    Microfrontend["EMBED_DEV_PORTAL"] = "embed-dev-portal";
    Microfrontend["HOME"] = "home";
    Microfrontend["DATA_MODEL"] = "data-model";
    Microfrontend["ADMIN"] = "admin";
    Microfrontend["SEEKWELL"] = "seekwell";
    Microfrontend["TEAMS"] = "teams";
    Microfrontend["COMS"] = "coms";
    Microfrontend["MONITOR"] = "monitor";
    Microfrontend["GLOBAL_NAV"] = "global-nav";
    Microfrontend["SEER"] = "seer";
    Microfrontend["CONV_ASSIST"] = "conv-assist";
    Microfrontend["EDGE"] = "edge";
    Microfrontend["COPILOT"] = "copilot";
    Microfrontend["WORKSHEET_V2"] = "worksheet-v2";
    Microfrontend["QUERY_VISUALIZER"] = "query-visualizer";
    Microfrontend["EMBRACE"] = "embrace";
    Microfrontend["CAPTAIN"] = "captain";
    Microfrontend["ONBOARDING"] = "onboarding";
    Microfrontend["SAGE_COACH"] = "sage-coach";
    Microfrontend["STATUS"] = "status";
    Microfrontend["DOC_SEARCH"] = "doc-search";
    Microfrontend["EUREKA_DATA_MODEL"] = "eureka-data-model";
    Microfrontend["NAVIGATION"] = "navigation";
    Microfrontend["LIVEBOARD"] = "liveboard";
    Microfrontend["ARSENAL"] = "arsenal";
    Microfrontend["AURORA"] = "aurora";
})(Microfrontend || (Microfrontend = {}));
export function logMicroFrontendsDebugInfo() {
    const microfrontends = window?.blink?.microfrontends;
    if (microfrontends?.isCdnEnabled) {
        logger.debug(`CDN Enabled: ${microfrontends.isCdnEnabled}`);
    }
    if (microfrontends?.cdnBasePath) {
        logger.debug(`CDN Base Path: ${microfrontends.cdnBasePath}`);
    }
    Object.values(Microfrontend).forEach(mfe => {
        if (microfrontends?.[mfe]?.releaseVersion) {
            logger.debug(`${mfe} version: ${microfrontends?.[mfe]?.releaseVersion}, path: ${microfrontends?.[mfe]?.path}, js: ${microfrontends?.[mfe]?.js}, css: ${microfrontends?.[mfe]?.css}`);
        }
    });
}
//# sourceMappingURL=index.js.map